export const CLIENT_CONSTANTS = {
    GET_CLIENTS_REQUEST: 'GET_CLIENTS_REQUEST',
    GET_CLIENTS_SUCCESS: 'GET_CLIENTS_SUCCESS',
    GET_CLIENTS_FAILURE: 'GET_CLIENTS_FAILURE',

    CREATE_CLIENT_REQUEST: 'CREATE_CLIENT_REQUEST',
    CREATE_CLIENT_SUCCESS: 'CREATE_CLIENT_SUCCESS',
    CREATE_CLIENT_FAILURE: 'CREATE_CLIENT_FAILURE',

    UPDATE_CLIENT_REQUEST: 'UPDATE_CLIENT_REQUEST',
    UPDATE_CLIENT_SUCCESS: 'UPDATE_CLIENT_SUCCESS',
    UPDATE_CLIENT_FAILURE: 'UPDATE_CLIENT_FAILURE',

    DELETE_CLIENT_REQUEST: 'DELETE_CLIENT_REQUEST',
    DELETE_CLIENT_SUCCESS: 'DELETE_CLIENT_SUCCESS',
    DELETE_CLIENT_FAILURE: 'DELETE_CLIENT_FAILURE',


    SEND_INVITATION_REQUEST: "SEND_INVITATION_REQUEST",
    SEND_INVITATION_SUCCESS: "SEND_INVITATION_SUCCESS",
    SEND_INVITATION_FAILURE: "SEND_INVITATION_FAILURE",
};